import { Interval } from '@debbie/common/dist/economy/payment-plans/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import { intervalLabel } from './labels.js';
const otherIntervals = [
    Interval.YEARLY,
    Interval.QUARTERLY,
    Interval['TWO-MONTHS'],
    Interval.MONTH,
    Interval['TWO-WEEKS'],
    Interval.WEEK,
];
const IntervalInput = (props) => {
    const { interval, onChange } = props;
    const lang = useSelector((s) => s.lang);
    const isActive = (target) => interval === target;
    return (React.createElement(Container, null,
        React.createElement(RecommendedOption, { type: "button", $active: isActive(Interval.LASTBANKDAYMONTH), onClick: () => onChange(Interval.LASTBANKDAYMONTH), "aria-pressed": isActive(Interval.LASTBANKDAYMONTH) },
            React.createElement(RecommendedRadio, { $active: isActive(Interval.LASTBANKDAYMONTH) }, isActive(Interval.LASTBANKDAYMONTH) && React.createElement(RadioDot, null)),
            React.createElement(RecommendedTextBlock, null,
                React.createElement(RecommendedTitleRow, null,
                    React.createElement(RecommendedTitle, null, lang.paymentPlans.lastBankDayOfMonth),
                    React.createElement(RecommendedBadge, null, lang.paymentPlans.recommendedBadge)),
                React.createElement(RecommendedDescription, null, lang.paymentPlans.lastBankDayOfMonthDescription))),
        React.createElement(OtherOptionsGrid, null, otherIntervals.map((opt) => (React.createElement(OptionPill, { key: opt, type: "button", $active: isActive(opt), onClick: () => onChange(opt), "aria-pressed": isActive(opt) }, intervalLabel(opt, lang)))))));
};
export default IntervalInput;
const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const RecommendedOption = styled.button `
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid
    ${(props) => (props.$active ? THEME.COLOR_ACCENT : THEME.BORDER_STRONG)};
  border-radius: 3px;
  background: ${(props) => (props.$active ? THEME.ACCENT_SURFACE : '#fff')};
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    border-color: ${(props) => (props.$active ? THEME.COLOR_ACCENT : THEME.BORDER_STRONG)};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }

  &:focus-visible {
    outline: none;
    border-color: ${THEME.COLOR_ACCENT};
    box-shadow: 0 0 0 3px ${THEME.ACCENT_SURFACE_STRONG};
  }
`;
const RecommendedRadio = styled.span `
  flex-shrink: 0;
  margin-top: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid
    ${(props) => (props.$active ? THEME.COLOR_ACCENT : THEME.BORDER_STRONG)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  transition: border-color 0.15s ease;
`;
const RadioDot = styled.span `
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${THEME.COLOR_ACCENT};
`;
const RecommendedTextBlock = styled.span `
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;
const RecommendedTitleRow = styled.span `
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;
const RecommendedTitle = styled.span `
  font-size: 15px;
  font-weight: 700;
  color: #111;
`;
const RecommendedBadge = styled.span `
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: ${THEME.COLOR_ACCENT};
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;
const RecommendedDescription = styled.span `
  font-size: 12px;
  color: ${THEME.TEXT_MUTED};
  line-height: 1.4;
`;
const OtherOptionsGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 8px;
`;
const OptionPill = styled.button `
  padding: 10px 12px;
  border: 1px solid
    ${(props) => (props.$active ? THEME.COLOR_ACCENT : THEME.BORDER_STRONG)};
  border-radius: 3px;
  background: ${(props) => (props.$active ? THEME.ACCENT_SURFACE : '#fff')};
  color: ${(props) => (props.$active ? THEME.COLOR_ACCENT : '#333')};
  font-size: 13px;
  font-weight: ${(props) => (props.$active ? 700 : 500)};
  cursor: pointer;
  font-family: inherit;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    border-color: ${(props) => (props.$active ? THEME.COLOR_ACCENT : THEME.BORDER_STRONG)};
    background: ${(props) => props.$active ? THEME.ACCENT_SURFACE_STRONG : THEME.SURFACE_INSET};
  }

  &:focus-visible {
    outline: none;
    border-color: ${THEME.COLOR_ACCENT};
    box-shadow: 0 0 0 3px ${THEME.ACCENT_SURFACE_STRONG};
  }
`;
//# sourceMappingURL=IntervalInput.js.map